import React from 'react';
export const InputContext = React.createContext();
//# sourceMappingURL=InputContext.js.map